export const TWO_FOR_ONE = 'TWO_FOR_ONE';
export const THREE_FOR_TWO = 'THREE_FOR_TWO';
export const TEN_PERCENT = 'TEN_PERCENT';
export const FIFTEEN_PERCENT = 'FIFTEEN_PERCENT';
export const TWENTY_PERCENT = 'TWENTY_PERCENT';
export const TWENTYFIVE_PERCENT = 'TWENTYFIVE_PERCENT';
export const THIRTY_PERCENT = 'THIRTY_PERCENT';
export const FORTY_PERCENT = 'FORTY_PERCENT';
export const FREE_SHIPPING = 'FREE_SHIPPING';
export const DISCOUNT_PRODUCTS = 'DISCOUNT_PRODUCTS';
export const FIXED_SHIPPING = 'FIXED_SHIPPING';
export const DISCOUNT_SHIPPING = 'DISCOUNT_SHIPPING';

export const promotionTranslate = promotion => {
  if (!promotion || !promotion.type) return 'En Promo';
  let promotionType = promotion.type;
  switch (promotionType) {
    case TWO_FOR_ONE:
      return '2x1';
    case THREE_FOR_TWO:
      return '3x2';
    case TEN_PERCENT:
      return '10% Off';
    case FIFTEEN_PERCENT:
      return '15% Off';
    case TWENTY_PERCENT:
      return '20% Off';
    case TWENTYFIVE_PERCENT:
      return '25% Off';
    case THIRTY_PERCENT:
      return '30% Off';
    case FORTY_PERCENT:
      return '40% Off';
    case FREE_SHIPPING:
      return 'Envío gratis';
    case DISCOUNT_PRODUCTS:
      return 'Descuento en productos';
    case FIXED_SHIPPING:
      return 'Envío fijo';
    case DISCOUNT_SHIPPING:
      return 'Descuento en envío';
    default:
      return 'En Promo';
  }
};

export const discountTranslate = discount => {
  if (!discount) return '';
  let discountEntity = discount.entity;
  switch (discountEntity) {
    case 'GiftCard':
      return `Giftcard: ${discount.code}`;
    case 'Coupon':
      return `Cupón: ${discount.code}`;
    default:
      return promotionTranslate(discount);
  }
};

export const promoIsLive = product => {
  if (!product) return false;
  if (!product.user?.promotion) return false;
  if (new Date(product.user.promotion.date_end) < new Date()) return false;
  return true;
};
